import {
  IconCircleCheck,
  IconMicrophoneOff,
  IconMicrophone,
  IconVideoOff,
  IconVideo,
  IconDroplet,
  IconDropletOff,
  IconSnowflake,
  IconSnowflakeOff,
  IconBroadcast,
  IconBroadcastOff,
  IconPlayerRecordFilled,
  IconFlag,
  IconFlag2,
  IconSquareFilled,
  IconPower,
} from "@tabler/icons-react";

export const AcceptIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return <IconCircleCheck size={22} color="#2B89E7" {...props} />;
};

export const MicOffIcon = (props: any) => {
  return (
    <IconMicrophoneOff
      size={props?.width || 98}
      color="#FF0707"
      role="button"
      {...props}
    />
  );
};

export const MicIcon = (props: any) => {
  return (
    <IconMicrophone
      size={props?.width || 34}
      color="#28A5FE"
      role="button"
      {...props}
    />
  );
};

export const VideoOffIcon = (props: any) => {
  return (
    <IconVideoOff
      size={props?.width || 150}
      color="#FF0707"
      role="button"
      {...props}
    />
  );
};

export const VideoIcon = (props: any) => {
  return <IconVideo size={168} color="#2145DA" {...props} />;
};

export function BlurIcon(props: any) {
  return <IconDroplet size={89} color="#29ABE2" {...props} />;
}

export function BulredIcon(props: any) {
  return <IconDropletOff size={93} color="#FF0707" {...props} />;
}

export function FreezIcon(props: any) {
  return <IconSnowflake size={128} color="#0957AF" {...props} />;
}

export function FreezedIcon(props: any) {
  return <IconSnowflakeOff size={128} color="#0957AF" {...props} />;
}

export function PublicViewer(props: any) {
  return (
    <svg
      {...props}
      width="80"
      height="80"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z"
        fill="url(#paint0_linear_1111_1123)"
      />
      <path
        d="M26.4062 39.8438C22.1875 39.8438 18.5938 43.2812 18.5938 47.6562C18.5938 52.0312 22.0312 55.4688 26.4062 55.4688C30.7812 55.4688 34.2188 52.0312 34.2188 47.6562C34.2188 43.2812 30.625 39.8438 26.4062 39.8438Z"
        fill="white"
      />
      <path
        d="M73.5938 39.8438C69.375 39.8438 65.7812 43.2812 65.7812 47.6562C65.7812 52.0312 69.2188 55.4688 73.5938 55.4688C77.8125 55.4688 81.4062 52.0312 81.4062 47.6562C81.4062 43.2812 77.9688 39.8438 73.5938 39.8438Z"
        fill="white"
      />
      <path
        d="M50 25.625C44.0625 25.625 39.2188 30.4687 39.2188 36.4062C39.2188 42.3438 44.0625 47.1875 50 47.1875C55.9375 47.1875 60.7813 42.3438 60.7813 36.4062C60.7813 30.4687 55.9375 25.625 50 25.625Z"
        fill="white"
      />
      <path
        d="M50 59.2188C40.1563 59.2188 31.5625 65.625 29.5312 74.375H70.4688C68.4375 65.625 59.8438 59.2188 50 59.2188Z"
        fill="white"
      />
      <path
        d="M73.5937 65.4688C73.125 65.4688 72.8125 65.4688 72.3438 65.4688C74.0625 68.125 75.3125 71.0937 75.9375 74.375H86.7188C85 69.2187 79.6875 65.4688 73.5937 65.4688Z"
        fill="white"
      />
      <path
        d="M26.4062 65.4688C20.3125 65.4688 15.1562 69.2187 13.2812 74.375H23.9062C24.5312 71.0937 25.7812 68.125 27.5 65.4688C27.1875 65.4688 26.7187 65.4688 26.4062 65.4688Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_1111_1123"
          x1="0"
          y1="0"
          x2="100"
          y2="0"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#0059FF" />
          <stop offset="1" stopColor="#FF9334" />
        </linearGradient>
      </defs>
    </svg>
  );
}

export function StreamingIcon(props: any) {
  return <IconBroadcast size={100} color="#F38200" {...props} />;
}

export function StreamingPalyed(props: any) {
  return <IconBroadcast size={100} color="#044191" fill="#044191" {...props} />;
}

export const BroadcastIcon = (props: any) => (
  <IconBroadcast size={props?.size || 24} {...props} />
);

export const BroadcastOffIcon = (props: any) => (
  <IconBroadcastOff size={props?.size || 24} {...props} />
);

export const RecordingIcon = (props: any) => (
  <IconPlayerRecordFilled size={props?.size || 22} {...props} />
);

export const QuickFlagIcon = (props: any) => (
  <IconFlag size={props?.size || 22} {...props} />
);

export const StartFlagIcon = (props: any) => (
  <IconFlag2 size={props?.size || 22} {...props} />
);

export const StopFlagIcon = (props: any) => (
  <IconSquareFilled size={props?.size || 22} {...props} />
);

export const EndIcon = (props: any) => (
  <IconPower size={props?.size || 22} {...props} />
);


export function RaisedHand(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width="800px"
      height="800px"
      viewBox="0 0 64 64"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      className="iconify iconify--emojione"
      {...props}
    >
      <g fill="#ffdd67">
        <path d="M10.3 9.9c-2.2 0-3.9 1.8-3.9 4v29.4h7.8V13.9c0-2.2-1.7-4-3.9-4M31.3 43.3h8.3V9.8c0-2.2-1.9-4.1-4.1-4.1-2.3 0-4.1 1.9-4.1 4.2-.1 0-.1 33.4-.1 33.4" />
      </g>
      <path
        d="M35.5 5.7c-.3 0-.5 0-.7.1 1.9.3 3.4 2 3.4 4v33.5h1.5V9.8c-.1-2.3-2-4.1-4.2-4.1"
        fill="#eba352"
      />
      <path
        d="M14.2 43.3h8.5V9.1c0-2.4-1.9-4.3-4.3-4.3s-4.3 1.9-4.3 4.3l.1 34.2"
        fill="#ffdd67"
      />
      <path
        d="M18.5 4.8c-.3 0-.5 0-.7.1 2 .4 3.5 2.1 3.5 4.3v21.3l1.5 2.1V9.1c0-2.4-1.9-4.3-4.3-4.3"
        fill="#eba352"
      />
      <path
        d="M22.8 40.5h8.5V6.3C31.3 3.9 29.4 2 27 2s-4.3 1.9-4.3 4.3l.1 34.2"
        fill="#ffdd67"
      />
      <g fill="#eba352">
        <path d="M27 2c-.3 0-.5 0-.7.1 2 .4 3.5 2.1 3.5 4.3v24.1l1.5 2.1V6.3C31.3 3.9 29.4 2 27 2M10.3 9.9c-.3 0-.5 0-.7.1 1.8.4 3.2 2 3.2 3.9v17.5l1.5 2.1V13.9c-.1-2.2-1.8-4-4-4" />
      </g>
      <path
        d="M57.7 29.3c-1.6-3.1-6.6-2.9-11.7 2.7-3.6 3.9-4.3 5.2-7.9 5.1V33s-31.7.1-31.7 2.6c0 0-1.5 11.1 1.6 18.1 4.6 10.4 26.2 12 35.3-4.9 5.3-10 16.1-16.2 14.4-19.5"
        fill="#ffdd67"
      />
      <g fill="#eba352">
        <path d="M57.7 29.3c-.3-.6-.7-1-1.2-1.4.1.1.2.2.2.4 1.7 3.4-3.4 6.9-7 10.5-2.9 2.9-5.7 5.9-7.1 9.4-6.4 15.3-25 15.3-32.8 8.3 7.1 8 27 8.7 33.8-7.3 1.5-3.5 4.1-6.4 7.1-9.4 3.6-3.7 8.7-7.2 7-10.5M39.1 37.1c-5.9-2.1-18.1 2-16.5 13.7 0-10.9 9.9-13.6 15.3-13.6.7-.1 1.2-.1 1.2-.1" />
      </g>
    </svg>
  )
}

